import React, {Component} from 'react';
import PropTypes from 'prop-types';
import FontAwesome from 'react-fontawesome';
import BrandEditor from '../../../components/BrandEditor'
import BrandLogisticsEditor from '../../../components/BrandLogisticsEditor';
import ProductEditor from '../../../components/ProductEditor';
import ProductList from '../../../components/ProductList';
import {Tab, Tabs, TabList, TabPanel} from 'react-tabs';
import Api from '../../../Api';

import './style.less';

export default class AdminBrandEdit extends Component {

  static contextTypes = {
    router: PropTypes.object
  };

  constructor(props) {
    super(props);

    this.brandUpdated = this.brandUpdated.bind(this);
    this.onNewProduct = this.onNewProduct.bind(this);
    this.onSelectProduct = this.onSelectProduct.bind(this);
    this.onProductUpdated = this.onProductUpdated.bind(this);
    this.onSelectTab = this.onSelectTab.bind(this);

    this.state = {
      brand: Api.cache.getBrand(props.params.brandToken),
      selectedProductToken: this.props.params.productToken || null,
      products: null,
      tabIndex: this.props.params.productToken ? 1 : 0
    };
  }

  componentWillMount() {
    Api.cache.addChangeListener(this.brandUpdated, Api.cache.eventTypes.BRANDS_CHANGED);
  }

  componentDidMount() {
    Api.getBrand(this.props.params.brandToken, true);

    Api.getBrandProducts(this.props.params.brandToken).then(
      (response) => {
        let products = response;
        if (!products || products.length === 0) {
          this.onNewProduct();
        } else {
          const productMap = products.reduce((map, product) => {
            map[product.token] = product;
            return map;
          }, {});
          this.setState({
            products: productMap,
            selectedProductToken: this.state.selectedProductToken || products[0].token,
          });
        }
      }
    );
  }

  componentWillUnmount() {
    Api.cache.removeChangeListener(this.brandUpdated, Api.cache.eventTypes.BRANDS_CHANGED);
  }

  brandUpdated() {
    this.setState({
      brand: Api.cache.getBrand(this.props.params.brandToken)
    });
  }

  onNewProduct(product) {
    let products = this.state.products || {};
    const numProducts = Object.keys(products).length;
    const token = `new-product-${numProducts}`;

    // Clear out name, description and any images tied to product or product options
    if (product) {
      product.name = '';
      product.description = '';
      delete product.images;

      product.options = (product.options || []).map(option => {
        let duplicatedOption = Api.Utils.clone(option);
        delete duplicatedOption.token;
        delete duplicatedOption.images;
        return duplicatedOption;
      })
    }

    let newProduct = product || {
        active: true,
        short_description: null,
        description: null,
        wholesale_price_cents: null,
        retail_price_cents: null,
        unit_multiplier: null,
        categories: [],
        images: []
      };

    newProduct.name = `Product ${numProducts}`;
    products[token] = newProduct;

    this.setState({
      products,
      selectedProductToken: token
    });
  }

  onSelectProduct(token) {
    const url = `/admin/brand/${this.props.params.brandToken}/product/${token}/edit`;
    this.context.router.push(url);
    this.setState({
      selectedProductToken: token
    });
  }

  onProductUpdated(token, product, newToken) {
    let products = this.state.products;

    // if newToken is set, have just created new product.
    // Update token in list
    if (newToken) {
      delete products[token];
      token = newToken;
    }

    products[token] = product;
    this.setState({
      selectedProductToken: token,
      products
    });
  }

  onSelectTab(tabIndex) {
    if (tabIndex === 0 || tabIndex === 2) {
      const url = `/admin/brand/${this.props.params.brandToken}/edit`;
      this.context.router.push(url);
    } else if (tabIndex === 1) {
      const url = `/admin/brand/${this.props.params.brandToken}/product/${this.state.selectedProductToken}/edit`;
      this.context.router.push(url);
    }

    this.setState({
      tabIndex
    });
  }

  render() {
    if (!this.state.brand) {
      return <div><FontAwesome name="circle-o-notch" spin/></div>;
    }

    let productView = <div><FontAwesome name="circle-o-notch" spin/></div>;
    if (this.state.products) {
      const products = this.state.products;
      const selectedProduct = products[this.state.selectedProductToken];
      productView = (
        <div className="admin-brand-edit-products-container">
          <ProductList onNew={this.onNewProduct}
                       onSelect={this.onSelectProduct}
                       selected={this.state.selectedProductToken}
                       products={products}
                       keyName="name"/>
          <ProductEditor product={selectedProduct}
                         brandToken={this.props.params.brandToken}
                         brandName={(this.state.brand && this.state.brand.name) || null}
                         onUpdated={this.onProductUpdated}
                         updateOnKey="name"
                         onDuplicate={this.onNewProduct}
                         token={this.state.selectedProductToken}
                         key={this.state.selectedProductToken}/>
        </div>);
    }
    return (
      <div className="admin-brand-edit-component">
        <h2>{this.state.brand.name}</h2>
        <Tabs selectedIndex={this.state.tabIndex} onSelect={this.onSelectTab}>
          <TabList>
            <Tab>Edit Brand</Tab>
            <Tab>Edit Products</Tab>
            <Tab>Edit Advanced</Tab>
          </TabList>
          <TabPanel>
            <BrandEditor brand={this.state.brand}/>
          </TabPanel>
          <TabPanel>
            {productView}
          </TabPanel>
          <TabPanel>
            <BrandLogisticsEditor logistics={this.state.brand}/>
          </TabPanel>
        </Tabs>
      </div>
    );
  }
}




/** WEBPACK FOOTER **
 ** ./src/views/admin/AdminBrandEdit/index.js
 **/